export const FETCH_START = "AUTH_FETCH_START";
export const FETCH_FAIL = "AUTH_FETCH_FAIL";
export const USER_SIGNED_IN = "AUTH_USER_SIGNED_ON";
export const USER_NOT_AUTHENTICATED = "AUTH_USER_NOT_AUTHENTICATED";
export const OPEN_SIGNIN_MODAL = 'AUTH_OPEN_SIGNIN_MODAL';
export const OPEN_SIGNUP_MODAL = 'AUTH_OPEN_SIGNUP_MODAL';
export const OPEN_PASSWORD_RECOVERY_MODAL = 'AUTH_OPEN_PASSWORD_RECOVERY_MODAL';
export const CLOSE_SIGNIN_MODAL = 'AUTH_CLOSE_SIGNIN_MODAL';
export const CLOSE_SIGNUP_MODAL = 'AUTH_CLOSE_SIGNUP_MODAL';
export const CLOSE_PASSWORD_RECOVERY_MODAL = 'AUTH_CLOSE_PASSWORD_RECOVERY_MODAL';
export const PASSWORD_RECOVERY_FETCHED = 'AUTH_PASSWORD_RECOVERY_FETCHED';